/* eslint-disable react/display-name */
import React from 'react';
import DynamicComponent from './DynamicComponent';
const withModule = (path)=>props=>{
    return <DynamicComponent path={path}  {...props}/>;
}
export default withModule;
